import React, { useEffect, useState } from "react";

import SettingsSidebar from "../../partials/settings/SettingsSidebar";
import { useSelector } from "react-redux";
import UsersTable from "../adminStores/usersTable.jsx";
import { getUsers } from "../../api/admin";

function Users() {
  const { selectedLocation } = useSelector((state) => state.app);
  const [users, setUsers] = useState([]);
  const _getUsers = async () => {
    await getUsers().then((res) => {
      setUsers(res.users);
    });
  };

  useEffect(() => {
    if (selectedLocation) {
      _getUsers();
    }
  }, [selectedLocation]);

  if (!selectedLocation) return null;

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      {/* Page header */}
      <div className="mb-8">
        {/* Title */}
        <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
          Users {selectedLocation?.name ? `for ${selectedLocation.name}` : ""}{" "}
          
        </h1>
      </div>

      {/* Content */}
      <div className="bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm mb-8">
        <div className="flex flex-col md:flex-row md:-mr-px">
          <div className="space-y-4 p-4 w-full">
            <UsersTable
              users={users}
              storeID={selectedLocation.id || selectedLocation._id}
              orgID={selectedLocation.org || selectedLocation._org || "000000000000000000000000"}
              storeName={selectedLocation.name}
              refetch={_getUsers}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Users;
